import React from "react";
import HealthEffectsTable from "./HealthEffectsTable";

function AirQualityDisplay({ data }) {
  if (!data || !data.list || data.list.length === 0) {
    return <div>Wczytujemy dane...</div>;
  }

  const aqi = data.list[0].main.aqi;
  const components = data.list[0].components;

  // Calculate EAQI - European Air Quality Index
  const calculateEAQI = (components) => {

    const breakpoints = {
      pm2_5: [
        { level: "Bardzo Dobra", max: 10 },
        { level: "Dobra", max: 20 },
        { level: "Dostateczna", max: 25 },
        { level: "Umiarkowana", max: 50 },
        { level: "Zła", max: 75 },
        { level: "Bardzo Zła", max: Infinity },
      ],
      pm10: [
        { level: "Bardzo Dobra", max: 20 },
        { level: "Dobra", max: 40 },
        { level: "Dostateczna", max: 50 },
        { level: "Umiarkowana", max: 100 },
        { level: "Zła", max: 150 },
        { level: "Bardzo Zła", max: Infinity },
      ],
      o3: [
        { level: "Bardzo Dobra", max: 50 },
        { level: "Dobra", max: 100 },
        { level: "Dostateczna", max: 120 },
        { level: "Umiarkowana", max: 180 },
        { level: "Zła", max: 240 },
        { level: "Bardzo Zła", max: Infinity },
      ],
      no2: [
        { level: "Bardzo Dobra", max: 40 },
        { level: "Dobra", max: 100 },
        { level: "Dostateczna", max: 150 },
        { level: "Umiarkowana", max: 200 },
        { level: "Zła", max: 400 },
        { level: "Bardzo Zła", max: Infinity },
      ],
      so2: [
        { level: "Bardzo Dobra", max: 50 },
        { level: "Dobra", max: 100 },
        { level: "Dostateczna", max: 350 },
        { level: "Umiarkowana", max: 500 },
        { level: "Zła", max: 750 },
        { level: "Bardzo Zła", max: Infinity },
      ],
      co: [
        { level: "Bardzo Dobra", max: 5000 },
        { level: "Dobra", max: 7500 },
        { level: "Dostateczna", max: 10000 },
        { level: "Umiarkowana", max: 20000 },
        { level: "Zła", max: 30000 },
        { level: "Bardzo Zła", max: Infinity },
      ],
    };

    // Find the highest index level among the pollutants
    let worstLevel = "Bardzo Dobra"; // Default to "Bardzo Dobra"
    Object.entries(components).forEach(([component, value]) => {
      if (breakpoints[component]) {
        const level = breakpoints[component].find((b) => value <= b.max).level;
        if (
          ["Bardzo Zła", "Zła", "Umiarkowana", "Dostateczna", "Dobra", "Bardzo Dobra"].indexOf(level) <
          ["Bardzo Zła", "Zła", "Umiarkowana", "Dostateczna", "Dobra", "Bardzo Dobra"].indexOf(worstLevel)
        ) {
          worstLevel = level;
        }
      }
    });

    return worstLevel;
  };

  const eaqiLevel = calculateEAQI(components);
  const isStinky =
    eaqiLevel === "Zła" ||
    eaqiLevel === "Bardzo Zła" ||
    eaqiLevel === "Umiarkowana";

  return (
    <div className="air-quality-display">
      <h1>We Wrocławiu dzisiaj</h1>
      {isStinky ? (
        <div>
          <h1 className="stinky-alert">Śmierdzi</h1>
          <h2>
            Jakość powietrza EAQI:{" "}
            <a
              href="https://smogopedia.pl/Indeksy_jako%C5%9Bci_powietrza"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b>{eaqiLevel}</b>
            </a>
          </h2>
          <HealthEffectsTable components={components} />
        </div>
      ) : (
        <div>
          <h1 className="not-stinky-alert">Nie Śmierdzi</h1>
          <h2>
            Jakość powietrza: <b>{eaqiLevel}</b>
          </h2>
          <p>Dzisiaj powietrze jest w porządku! Hurra!!</p>
        </div>
      )}
    </div>
  );
}

export default AirQualityDisplay;